import {
  BsGithub,
  BsEnvelope,
  BsFacebook,
  BsTwitter,
  BsLinkedin,
  BsCloudMoonFill,
  BsSunFill,
} from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
const Header = () => {
  const [state, setState] = useState(false);
  const el = useRef(document.documentElement);
  const imageMove = useRef("");
  const images = document.querySelectorAll("#images");
  console.log(images);
  images.forEach((img) => {
    img.addEventListener("click", () => {
      images.forEach((image) => {
        image.classList.remove("flex-[1]");
      });
      img.classList.add("flex-[1]");
    });
  });
  const toggleTheme = () => {
    const dark = localStorage.getItem("dark");
    console.log(dark);
    if (dark) {
      disable();
      setState(false);
    } else {
      enable();
      setState(true);
    }
  };
  function disable() {
    el.current.classList.remove("dark");
    localStorage.removeItem("dark");
  }

  function enable() {
    el.current.classList.add("dark");
    localStorage.setItem("dark", "enabled");
  }
  useEffect(() => {
    const darkMode = localStorage.getItem("dark");
    if (darkMode) {
      el.current.classList.add("dark");
      setState(true);
    } else {
      el.current.classList.remove("dark");
      setState(false);
    }
  }, []);
  return (
    <header className="header relative">
      <div className="fixed top-6 right-6 z-[200] flex items-center justify-center bg-teal-600 rounded-full w-10 h-10">
        {state ? (
          <li
            className=" list-none text-white md:text-lg cursor-pointer "
            onClick={toggleTheme}
          >
            <BsSunFill />
          </li>
        ) : (
          <li
            className="list-none text-white md:text-lg cursor-pointer "
            onClick={toggleTheme}
          >
            <BsCloudMoonFill />
          </li>
        )}
      </div>
      <div className="container-block z-10">
        <div className="header-logo flex justify-between">
          <span className="header-logo-brand">shakil</span>
        </div>
        <div className="header-row">
          <div className="header-col pr-7 text-center md:text-left">
            <h4 className="text-lg font-medium dark:text-white">
              Hello my name is
            </h4>
            <h1 className="header-heading">shakil khan</h1>
            <h3 className="header-subheading leading-[33px] w-[80%]">
              I'm an{" "}
              <span className="font-bold">
                {" "}
                independent creative full stack{" "}
              </span>{" "}
              web developer
            </h3>
            <div className="mt-[18px] flex items-center flex-col md:flex-row">
              <a
                href="./shakilkhan.pdf"
                target="_blank"
                className="btn btn-default"
              >
                download CV
              </a>
              &nbsp;&nbsp;&nbsp;
              <a
                href="mailto:shakilkhan621@gmail.com"
                className=" font-medium dark:text-white"
              >
                Hire me!
              </a>
            </div>
          </div>
          <div className="header-col z-50 lg:hidden">
            <div className="w-full max-h-[400px] h-full relative rounded-md overflow-hidden">
              <img src="./images/shakil.jpg" alt="" className="" />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 right-0 w-[50%] h-full hidden lg:block">
        <img
          src="./images/shakil.jpg"
          alt="user image"
          className="w-full h-full object-cover block rounded-bl-full"
        />
      </div>
    </header>
  );
};

export default Header;
